<template>
  <div class="goods_freeget">
    <!-- 大图拼接 -->
    <div class="content" v-html="defaultGoods.guideContent" @click="getVip($event)"></div>
    <!-- <div class="card">
      <img src="../../../images/goods/activity/goods_freeget_card.png" alt="">
    </div> -->
    <!-- 设计文案
    <div class="page-title">
      <div class="title">友邻少年发放福利啦！</div>
      <div>免费领取90天会员VIP</div>
    </div>
    <div class="page-vip">
      <div class="vip-card">
        <div>90天会员VIP</div>
        <div>
          <span>原价</span>
          <del>￥399</del>
        </div>
        <div>
          畅听友邻所有课程
        </div>
      </div>
    </div>
    <div class="page-vip-get">
      <mt-button
        type="primary"
        size="small"
        @click="getVip"
        class="btn-free"
      >免费领取</mt-button>
      <span>限量500个名额，先到先得哦</span>
    </div>
    <div class="page-role">
      <div class="role-title">活动规则</div>
      <div class="role-text">1.新用户可免费领取90天会员vip,限量500个名额,先到先得</div>
      <div class="role-text">2.领取成功后将收到友邻送的礼品卡,可下载友部优课APP,进入我的-卡券页面查看并使用</div>
    </div> -->
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import Body from '@/mixins/body'
import UseShareCode from '@/mixins/body/use-sharecode'
import { toLoginView } from '@/utils/init/env-init'
import { throttle } from '@/utils'

// 商品免费领取
const action = 'freegetGoods'

export default {
  name: 'goods_freeget',
  mixins: [Body, UseShareCode],
  data() {
    return {
      title: '友邻季卡免费领',
      $actionName: action
    }
  },
  methods: {
    // 设置分享数据
    setShareData() {
      const { shareMainTitle: title, shareSecondTitle: desc, shareImg: imgUrl } = this.defaultGoods
      if (title) {
        const link = location.href
        return { title, desc, link, imgUrl }
      }
    },
    getVip: throttle(
      function ($event) {
        // 无token去登录
        if (!this.hasToken({ action })) {
          toLoginView({ type: 'button', action })
          return
        }

        const { target } = $event || {}
        // 商品卡片图片，需要手动追加样式
        if (target && target.className.indexOf('button-card') === -1) {
          return
        }
        // sharecode
        const goodsId = this.defaultGoodsId
        const data = { goodsId }
        this.$store.dispatch('goods/vip/getGiftCard', data).then(res => {
          // 增加提示
          Toast({ message: '您已领取成功', position: 'middle' })
          // // 进入成功页面
          // const name = 'success'
          // const { iconUrl, nikeName, adviserCode } = res
          // const payStatus = { goodsId, iconUrl, nikeName, adviserCode,
          //   isFrereget: true // 免费领取
          // }
          // // 如果无订单 // 仅提示
          // const params = { id: goodsId }
          // this.$store.commit('payment/order/setPayStatus', payStatus)
          // this.$router.replace({ name, params })
        })
      },
      2000,
      { leading: true }
    )
  }
}
</script>

<style lang="less" scoped>
.goods_freeget {
  // padding: .48rem;
  .content {
    img {
      display: block;
      width: 100%;
      height: auto;
      margin: -1px 0px;
    }
  }
  // 卡的外观
  .card {
    position: absolute;
    top: 7.5rem;
    left: 14%;
    border-radius: 10px;
    img {
      width: 84%;
      height: auto;
    }
    // &.card:hover {
    //   border: 1px solid #e9e9e9;
    // }
  }

  // 标题
  .page-title {
    margin: 40px 0;
    text-align: center;
    margin-bottom: 0.24rem;
    .title {
      font-size: 0.3rem;
      font-weight: bold;
    }
  }
  // VIP卡
  .page-vip {
    margin-bottom: 0.24rem;
    .vip-card {
      background-color: wheat;
      padding: 0.24rem;
    }
  }

  // 免费领取
  .page-vip-get {
    margin-bottom: 0.24rem;
    text-align: center;
    .btn-free {
      width: 100%;
      margin-bottom: 0.24rem;
    }
  }

  // 活动规则
  .page-role {
    margin-bottom: 0.24rem;
    font-size: 0.3rem;
    .role-title {
      font-weight: bold;
    }
  }
}
</style>
